import createDOMPurify from "dompurify";
import styles from "./RichTextContent.module.css";

const ALLOWED_TAGS = [
  "p",
  "br",
  "h2",
  "h3",
  "strong",
  "em",
  "u",
  "ul",
  "ol",
  "li",
  "blockquote",
  "a",
];
const ALLOWED_ATTRIBUTES = ["href", "target", "rel"];
const ALLOWED_URI_REGEXP = /^(?:https?|mailto):/i;
const purifier = createDOMPurify(window);

purifier.addHook("uponSanitizeAttribute", (node, data) => {
  if (node.nodeName.toLowerCase() !== "a") {
    data.keepAttr = false;
  } else if (data.attrName === "target") {
    data.forceKeepAttr = true;
  }
});

purifier.addHook("afterSanitizeAttributes", (node) => {
  if (
    node instanceof HTMLAnchorElement &&
    node.getAttribute("target") === "_blank"
  ) {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

type RichTextContentProps = {
  value?: string | null;
  format?: string | null;
  className?: string;
};

export function RichTextContent({
  value,
  format,
  className,
}: RichTextContentProps) {
  if (!value) return null;

  const classNames = `${styles.content}${className ? ` ${className}` : ""}`;

  if (format === "html") {
    const sanitizedValue = purifier.sanitize(value, {
      ALLOWED_TAGS,
      ALLOWED_ATTR: ALLOWED_ATTRIBUTES,
      ALLOWED_URI_REGEXP,
      ALLOW_ARIA_ATTR: false,
      ALLOW_DATA_ATTR: false,
    });

    return (
      <div
        className={classNames}
        dangerouslySetInnerHTML={{ __html: sanitizedValue }}
      />
    );
  }

  return (
    <div className={`${classNames} ${styles.plain}`}>
      {value.replace(/\/n /gi, "\n")}
    </div>
  );
}
